export const COMMENT_ATTACHMENT_MAX_FILES = 20
export const COMMENT_ATTACHMENT_MAX_SIZE = 20 * 1024 * 1024
export const COMMENT_ATTACHMENT_TYPES = new Set([
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "text/csv",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "application/x-excel",
  "application/x-msexcel",
  "image/png",
  "image/jpeg",
  "image/gif",
])

export const COMMENT_ATTACHMENT_ACCEPT = Array.from(COMMENT_ATTACHMENT_TYPES).join(",")

export function commentAttachmentBatchError(fileCount: number, existingCount: number): string | null {
  if (fileCount + existingCount <= COMMENT_ATTACHMENT_MAX_FILES) return null

  return `Comments can have up to ${COMMENT_ATTACHMENT_MAX_FILES} attachments`
}

export function commentAttachmentError(file: Pick<File, "name" | "size" | "type">): string | null {
  if (!COMMENT_ATTACHMENT_TYPES.has(file.type)) {
    return `${file.name || "File"} is not a supported file type`
  }

  if (file.size > COMMENT_ATTACHMENT_MAX_SIZE) {
    return `${file.name || "File"} must be 20 MB or smaller`
  }

  return null
}
